// ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import useStore from "../Screen/redux/store/useStore";

// Map module_codes to their corresponding paths
const moduleCodeToPath = {
  dashboard: "/dashboard",
  admins: "/admin",
  role_maping: "/role",
  client: "/client-list",
  admin_recharge: "/admin-recharge",
  recharge_history: "/recharge-history",
  widraw_history: "/withdraw-history",
  announce_result: "/announce-result",
  overall_result: "/overall-result",
  reports: "/report",
  commission_history: "/commission",
  announcements: "/announcement",
  holiday_update: "/holiday-update",
  links: "/add-link",
  lot_price_details: "/lot-price",
  price_details: "/cash-agency",
  app_time_setting: "/app-time",
  help_and_support: "/help-support",
  delete_data: "/delete-data",
  client_activity: "/client-activity",
  blocked_client_list: "/blocked-client",
  draw_status: "/draw-status",
};

const ProtectedRoute = ({ moduleCode, children }) => {
  const storedata = useStore();
  const { role, user, permissions } = storedata;
  const navigate = useNavigate();

  // ✅ Super admin
  if (role === true) {
    return children;
  }

  const hasPermission = permissions.some(
    (item) => item?.module_code === moduleCode,
  );

  if (!hasPermission) {
    // User doesn't have permission for this route
    // Find the first allowed module_code and redirect there
    if (permissions.length > 0) {
      const firstAllowedModule = permissions[0]?.module_code;
      const redirectPath = moduleCodeToPath[firstAllowedModule];

      if (redirectPath) {
        console.log("Redirecting to first allowed path:", redirectPath);
        return <Navigate to={redirectPath} replace />;
      }
    }

    // If no permissions or no valid path found, redirect to login
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
